import * as React from 'react';
import Grid from '@mui/material/Grid';
import GitHubIcon from '@mui/icons-material/GitHub';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import MainFeaturedPost from './MainFeaturedPost';
import FeaturedPost from './FeaturedPost';
import Main from './Main';
import Sidebar from './Sidebar';
import { getAllBlogs, getBlogs, getHeaderBlogs, getTopBlogs } from './core/Apis';
import Loading from './core/Loading';
import { checkText, strip } from './core/Helpers';
import { Helmet } from 'react-helmet';



export default function News(props) {
      const [loading, setLoading] = React.useState(true)
      const [mainFeaturedPost, setmainFeaturedPost] = React.useState({});
      const [featuredposts, setfeaturedposts] = React.useState([]);
      const [sidebar, setsidebar] = React.useState({});
      const [posts, setposts] = React.useState([])
      const [limit, setLimit] = React.useState(10)
      const [offset, setoffset] = React.useState(0)
      const postsResults = async (x) => {
            let postsFeature = [];
            // change links to Link word with hover
            await x?.forEach(async (element, xds) => {
                postsFeature.push({
                    title: await checkText(strip(element.title).substring(0, 100) + (element.title.length > 100 ? '...' : '')),
                    date: (new Date(element.updated_at || '')).toLocaleDateString(),
                    link: `/v2/news/${element.path}`,
                    description: await checkText(strip(element.body).substring(0, 100)+ (element.body.length > 100 ? '...': '')),
                    image: element.image,
                    author: x[0].author?.title || 'Tech Source',
                    categories: x[0].categories,
                    tags: x[0].tags,
                    imageLabel: element.title,
                    imageText: element.title,
                  })
            });
            return postsFeature ;
      }
      const viewsResults = async (x) => {
        let postsFeature = [];
        // change links to Link word with hover
        await x?.forEach(async (element, xds) => {
            postsFeature.push({
                title: await checkText(strip(element.title).substring(0, 100) + (element.title.length > 100 ? '...' : '')),
                date: (new Date(element.updated_at || '')).toLocaleDateString(),
                link: `/v2/news/${element.path}`,
                description: await checkText(strip(element.body).substring(0, 100)+ (element.body.length > 100 ? '...': '')),
                image: element.image,
                author: x[0].author?.title || 'Tech Source',
                categories: x[0].categories,
                tags: x[0].tags,
                imageLabel: element.title,
                imageText: element.title,
              })
        });
        return postsFeature ;
  }
      // Update all
      React.useEffect(() => {
       getHeaderBlogs('news').then(async x => {
            return setmainFeaturedPost({
            title: await checkText(strip(x[0].title).substring(0, 100) + (x[0].title.length > 100 ? '...': '')),
            description: await checkText(strip(x[0].body).substring(0, 100) + (x[0].body.length > 100 ? '...': '')),
            image: x[0].image,
            author: x[0].author?.title || 'Tech Source',
            categories: x[0].categories,
            tags: x[0].tags,
            imageText: x[0].title,
            imageLabel: x[0].title,
            link: `/v2/news/${x[0].path}`,
            linkText: x[0].title,
        })})
        // featured
       getAllBlogs(10, 0, 'news').then(async x =>
        {
           return setfeaturedposts(await postsResults(x))
        }
        )
       getBlogs(limit, offset, 'news').then(async x =>
            {
              return setposts(await postsResults(x))
            }
        )
       getTopBlogs('news').then(async x =>
            {
               const topten = await viewsResults(x);  
               return await setsidebar(
                {
                    title: topten[0].title,
                    description: topten[0].description,
                    archives: topten,
                    social: [
                      { name: 'GitHub', icon: GitHubIcon },
                      { name: 'Twitter', icon: TwitterIcon },
                      { name: 'Facebook', icon: FacebookIcon },
                    ],
                  }
               )
           
            }
        )
        setTimeout(() => {
            setLoading(false)
        }, 3000);
      }, [])
      
   if(loading){
        return (<>
                <Loading width={"100%"} />
              </>)
    }
  return (<>
           <Helmet>
              <meta charSet="utf-8" />              
              <title>RealLexi | The Real Word Blog</title>
              <meta name="title" content="RealLexi | The Real Word Blog"/>
                <meta name="robots" content="all, index, follow"/>
                <meta name="description" content="RealLexi | The Real Word Blog, is not like any other blog on the inter..."/>
                <meta name="keywords" content="RealLexi | The Real Word Blog, reallexi, real lexi, real, word, ddkits..."/>
                <meta name="author" content="DDKits"/>
                <link rel="canonical" href="https://reallexi.com"/>
                <meta property="og:title" content="RealLexi | The Real Word Blog"/>
                <meta property="og:image" content="/uploads/files/1/illustration.svg"/>
                <meta property="og:locale" content="en_US"/>
                <meta property="og:url" content="https://reallexi.com"/>
                <meta property="og:sitename" content="RealLexi | The Real Word Blog"/>
                <meta property="og:description" content="RealLexi | The Real Word Blog, is not like any other blog on the inter..."/>
                <meta name="twitter:title" content="RealLexi | The Real Word Blog"/>
                <meta name="twitter:image" content="/uploads/files/1/illustration.svg"/>
                <meta name="twitter:url" content="https://reallexi.com"/>
                <meta name="twitter:card" content="RealLexi | The Real Word Blog, is not like any other blog on the inter..."/>
              
                <script type="application/ld+json">
                {`{
                  "@context": "https://schema.org",
                  "@type": "Blog",
                  "url": "${window.location.href}",
                  "name": "RealLexi | The Real Word Blog",
                  "author": {
                    "@type": "Organization",
                    "name": "RealLexi"
                  },
                  "description": "RealLexi | The Real Word Blog, is not like any other blog on the inter..."
                }`} 
              </script>
        </Helmet>
         <MainFeaturedPost post={mainFeaturedPost} />
         <Grid container spacing={4}>
            {featuredposts?.length > 0 && featuredposts?.map((post, xds) => (
              <FeaturedPost key={xds} post={post} />
            ))}
            
          </Grid>
           
          <Grid container spacing={5} sx={{ mt: 3 }}>
            {posts?.length > 0 && <Main title="Recent Articles" posts={posts} />}
            {sidebar.title && <Sidebar
              title={sidebar.title}
              description={sidebar.description}
              archives={sidebar.archives}
              social={sidebar.social}
            />}
          </Grid>
          <button onClick={() => getBlogs(limit, offset+10, 'news').then(async x =>
                {
                  setoffset(offset+10);
                  const newList = await postsResults(x);
                  return setposts(posts?.concat(newList))
                }
            )}  className="btn btn-primary center" >Show More</button>
        </>
 );
}
